import { useState, useEffect, useCallback } from 'react';
import request from '../../utils/request';

// `enabled: false` skips the initial fetch, for callers that already hold the
// project's design_process_status and cannot change it - a read-only list would
// otherwise fire one request per card.
export default (projectId, { enabled = true } = {}) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(
    () => {
      setLoading(true);
      request('get', `/projects/${projectId}/design_process_status`)
        .then(({ design_process_status: status }) => {
          setStatus(status);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [projectId],
  );

  const update = useCallback(
    newStatus => {
      const oldStatus = status;
      setStatus(newStatus);

      request('put', `/design/projects/${projectId}`, {
        project: { design_process_status: newStatus },
      })
        .then(({ project: { design_process_status } }) => {
          setStatus(design_process_status);
        })
        .catch(() => {
          setStatus(oldStatus);
        });
    },
    [projectId, status],
  );

  useEffect(
    () => {
      if (enabled) {
        fetch();
      }
    },
    [projectId, enabled],
  );

  return {
    status,
    loading,
    fetch,
    update,
  };
};



// WEBPACK FOOTER //
// ./app/javascript/common/components/DesignStatus/useDesignStatus.js